import React from 'react'
import { getPublicLayout } from '@public/components/PublicLayout'
import { Box } from 'components/Layout'
import { H2, H3, LI, Paragraph, Strong } from 'components/Legal'
import { PureSSRIndicator } from 'components/PureSSRIndicator'
import { SPACE } from 'Theme'
import { prepareGetStaticNavigationProps } from '../utils/prepareGetStaticNavigationProps'

export const PriceMatchPromiseTerms = () => (
  <Box mt={SPACE.PX_80} mb={SPACE.PX_120}>
    <H2>Price Match Promise Terms and Conditions</H2>
    <H3>Effective Date: July 1, 2025</H3>
    <H3>Expiration Date: September 30, 2025</H3>
    <br />

    <Paragraph>
      <Strong>1. Eligibility</Strong>{' '}
    </Paragraph>
    <ul>
      <LI>
        The Price Match Promise applies exclusively to products purchased
        through The Expert&apos;s platform by verified logged-in Trade Members
        in The Expert Trade Program
      </LI>
    </ul>
    <Paragraph>
      <Strong>2. Price Matching</Strong>{' '}
    </Paragraph>
    <ul>
      <LI>
        We will match the price of products listed with identical specifications
        listed at a lower price directly by the brand, provided the price match
        request meets the following criteria:
        <ul>
          <LI>
            The lower price must be readily available for validation (via quote,
            link, or screenshot) at the time of the request.
          </LI>
          <LI>
            The product must be identical in brand, model, and specifications.
          </LI>
        </ul>
      </LI>
    </ul>
    <Paragraph>
      <Strong>2. Exclusions</Strong>{' '}
    </Paragraph>
    <ul>
      <LI>
        The following are not eligible for price matching:
        <ul>
          <LI>
            Promotional pricing (e.g., new customer discounts, Black Friday or
            seasonal sales).
          </LI>
          <LI>Clearance or closeout items.</LI>
          <LI>Shipping costs or other additional fees.</LI>
        </ul>
      </LI>
      <LI>
        Products from retailers not featured on The Expert (including but not
        limited to third party retailers, marketplaces, re-sale sites, etc.) are
        excluded from price matching.) Specific retailer eligibility is
        determined at The Expert&apos;s discretion.
      </LI>
      <LI>
        Price matching excludes typographical errors, volume-based discounts,
        time-sensitive or quantity-dependent promotions, flash deals, coupon
        codes (such as a welcome discount), credit card-specific discounts, gift
        card promotions, financing offers, bundled discounts, sales tax
        incentives, and free item giveaways.
      </LI>
      <LI>Samples are excluded from price matching.</LI>
      <LI>
        Some brand exclusions may apply. The Expert reserves the right to
        determine and update excluded brands at its discretion.
      </LI>
    </ul>
    <Paragraph>
      <Strong>4. Submission Requirements</Strong>{' '}
    </Paragraph>
    <ul>
      <LI>
        To request a price match, submit a screenshot or documented proof of
        lower price to{' '}
        <a href="mailto:trade@theexpert.com">trade@theexpert.com</a>.
      </LI>
      <LI>
        Requests must be submitted prior to purchase. Refunds for previously
        purchased items will not be available.{' '}
      </LI>
    </ul>
    <Paragraph>
      <Strong>5. Approval Process</Strong>{' '}
    </Paragraph>
    <ul>
      <LI>
        All price match requests are subject to review and approval by The
        Expert&apos;s team.
      </LI>
      <LI>
        The Expert reserves the right to decline any price match request at its
        sole discretion, regardless of eligibility or supporting documentation
        provided.
      </LI>
    </ul>
    <Paragraph>
      <Strong>6. Program Limitations</Strong>{' '}
    </Paragraph>
    <ul>
      <LI>
        This program is subject to change or termination at any time without
        prior notice.
      </LI>
      <LI>
        Price matching applies only to product pricing and excludes additional
        services or fees, including but not limited to shipping costs, rush
        fees, taxes and duties, etc.
      </LI>
    </ul>
    <Paragraph>
      <Strong>7. Validity</Strong>{' '}
    </Paragraph>
    <ul>
      <LI>
        Approved price matches are valid for purchases placed between July 1,
        2025 and September 30, 2025.
      </LI>
    </ul>
    <Paragraph>
      For further questions, please contact{' '}
      <a href="mailto:trade@theexpert.com">trade@theexpert.com</a>.
    </Paragraph>
    <PureSSRIndicator />
  </Box>
)

export function getStaticProps() {
  return prepareGetStaticNavigationProps()
}

PriceMatchPromiseTerms.getLayout = (page) =>
  getPublicLayout(page, { isWithBreadcrumbs: true })
